import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { isSettingsOptionSet } from "./settingsOptionSet";
import { SystemOptionSet } from "./SystemOptionSetEnum";

export function isSystemOptionSet(handle: DocEntityHandle): boolean {
  if (handle.type !== "OPTION_SET") {
    return false;
  }

  return Object.values<string>(SystemOptionSet).includes(handle.id) || isSettingsOptionSet(handle.id);
}

export function isSystemOptionSetId(optionSetId: string): boolean {
  return Object.values<string>(SystemOptionSet).includes(optionSetId);
}

export function isElevationOptionSet(optionSetId: string): boolean {
  return optionSetId === SystemOptionSet.ELEVATION_STYLE;
}

export function isMirrorOptionSet(optionSetId: string): boolean {
  return optionSetId === SystemOptionSet.MIRROR;
}

export function isPaletteOptionSet(optionSetId: string): boolean {
  return optionSetId === SystemOptionSet.INTERIOR_PALETTE;
}
